import {
  cn,
  DataTable,
  DataTablePagination,
  DataTableToolbar,
  useTableContext,
} from "@bleu.builders/ui";
import { FolderHeart, Heart } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

import { ToggleFormAction } from "#/components/ToggleFormAction";
import { withPaywall } from "#/components/WithPaywall";
import { useUser } from "#/contexts/UserContext";
import { formatDate } from "#/lib/formatDate";
import { UserPagePath } from "#/lib/pagesHelper";
import { canViewNewsArticle } from "#/lib/permissions";
import { truncateHtmlContent } from "#/lib/utils";
import { useSWRDataTableWithRedirect } from "#/utils/useSWRDataTableWithRedirect";

import { CATEGORY_COLORS } from "./index";

function TableItems() {
  // @ts-expect-error TS(2339) FIXME: Property 'table' does not exist on type '{}'.
  const { table } = useTableContext();
  const { user } = useUser();

  const getRowItem = (row, name) => {
    return row
      .getVisibleCells()
      .find((cell) => cell.column.id === name)
      ?.getValue();
  };

  return (
    <>
      <div className="grid grid-cols-3 items-stretch">
        {table.getRowModel().rows?.length ? (
          table.getRowModel().rows.map((row, index: number, list) => (
            <Link
              to={UserPagePath.NEWS_ARTICLES + `/${row.original.id.toString()}`}
              key={row.original.id}
            >
              <div
                className={cn(
                  "max-w-lg mx-auto mb-10 hover:scale-[101%] py-4",
                  {
                    "border-r": index % 3 !== 2 && index !== list.length - 1,
                    "px-4": index % 3 === 1,
                    "pr-4": index % 3 === 0,
                    "pl-4": index % 3 === 2,
                  },
                )}
              >
                <div className="mb-2 flex justify-between">
                  {getRowItem(row, "category") && (
                    <div
                      className={cn(
                        "text-xs font-semibold py-0.5 rounded uppercase flex gap-2",
                        CATEGORY_COLORS[getRowItem(row, "category")],
                        "bg-background",
                      )}
                    >
                      <span className="">{getRowItem(row, "category")}</span>
                      <ToggleFormAction
                        Icon={Heart}
                        tooltip="Favoritar"
                        actionPath={
                          row.original.actions.find(
                            (r) => r.name == "Favoritar",
                          ).url_path
                        }
                        defaultSelected={row.original.favorited}
                      />
                      <ToggleFormAction
                        Icon={FolderHeart}
                        tooltip="Salvar para ler depois"
                        actionPath={
                          row.original.actions.find(
                            (r) => r.name == "Ler depois",
                          ).url_path
                        }
                        defaultSelected={row.original.read_later_saved}
                      />
                    </div>
                  )}
                  <p className="text-sm text-gray-500">
                    {getRowItem(row, "published_at") &&
                      formatDate(getRowItem(row, "published_at"))}
                  </p>
                </div>
                <div className="mb-4">
                  <h1 className="text-lg font-bold mt-2">
                    {getRowItem(row, "title")}
                  </h1>
                </div>
                <div className="font-light">
                  {getRowItem(row, "content") &&
                    truncateHtmlContent(getRowItem(row, "content"), 1)}
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="mt-4 w-full mr-4 overflow-y-auto max-h-[80vh] min-h-[10vh]">
            Nenhum resultado encontrado.
          </div>
        )}
      </div>
    </>
  );
}

function NewsArticlesLatestTable() {
  const { data, error, isLoading, tableState, setTableState } =
    useSWRDataTableWithRedirect(UserPagePath.NEWS_ARTICLES_LATEST, {
      pagination: {
        pageIndex: 0,
        pageSize: 12,
      },
    });

  if (isLoading) {
    <div className="mt-4 w-full mr-4 overflow-y-auto max-h-[80vh] min-h-[10vh]">
      Carregando...
    </div>;
  }

  return (
    <div className=" space-y-4 pb-10">
      <span className="border-b-2 border-primary text-lg font-bold">
        Últimos conteúdos
      </span>
      <DataTable
        data={data}
        error={error}
        tableState={tableState}
        setTableState={setTableState}
        setSelectedData={null}
        setQueryToParams={true}
      >
        <div className="space-y-4">
          <DataTableToolbar action={null} showViewOptions={false} />
          <div>
            <TableItems />
          </div>
          <DataTablePagination itemsPerPageOptions={[12, 24, 36, 48]} />
        </div>
      </DataTable>
    </div>
  );
}

export default withPaywall(NewsArticlesLatestTable, canViewNewsArticle);
